export const getDeviceType = function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // console.log('userAgent', userAgent)
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i) || userAgent.match(/Mac/i) || userAgent.match(/Ios/i)) {
        return 'iOS';
    } else if (userAgent.match(/Android/i)) {
        return 'Android';
    } 
    // else if (userAgent.match(/HarmonyOS/i)) {
    //     return 'HarmonyOS';
    // }
    // console.log('未知平台');
    // return 'unknown';
    // if (userAgent.match(/(iPhone|iPad|iPod)/i)) {
    //     return 'iOS';
    // } else if (userAgent.match(/Android/i)) {
    //     return 'Android';
    // } else if (userAgent.match(/HarmonyOS/i)) {
    //     return 'HarmonyOS';
    else {
        console.log('未知平台');
        return 'unknown';
    }
}

